import { apiClient } from './client';
import type {
  Client,
  ClientListResponse,
  ClientStats,
  CreateClientDto,
  UpdateClientDto,
} from '@/types/client.types';

export interface ListClientsParams {
  page?: number;
  pageSize?: number;
  search?: string;
  estatus?: string;
}

// --- Jugadores del cajero (panel operator, scoped a invitedByOperatorId) ---

export type MyClientStatus = 'active' | 'blocked';

export interface MyClient {
  id: string;
  casinoUsername: string;
  nombre: string;
  estatus: MyClientStatus | (string & {});
  createdAt: string;
  invitedByOperatorId: string | null;
  // Etiqueta del link por el que se registró; null = link general.
  inviteLabel: string | null;
}

export interface ListMyClientsParams {
  search?: string;
  limit?: number;
  offset?: number;
}

export const clientsApi = {
  list: async (params: ListClientsParams = {}): Promise<ClientListResponse> => {
    const { data } = await apiClient.get<ClientListResponse>('/admin/clients', { params });
    return data;
  },

  stats: async (): Promise<ClientStats> => {
    const { data } = await apiClient.get<ClientStats>('/admin/clients/stats');
    return data;
  },

  get: async (id: string): Promise<Client> => {
    const { data } = await apiClient.get<Client>(`/admin/clients/${id}`);
    return data;
  },

  create: async (dto: CreateClientDto): Promise<Client> => {
    const { data } = await apiClient.post<Client>('/admin/clients', dto);
    return data;
  },

  update: async (id: string, dto: UpdateClientDto): Promise<Client> => {
    const { data } = await apiClient.put<Client>(`/admin/clients/${id}`, dto);
    return data;
  },

  remove: async (id: string): Promise<void> => {
    await apiClient.delete(`/admin/clients/${id}`);
  },

  importCsv: async (file: File): Promise<{ imported: number; errors: number }> => {
    const form = new FormData();
    form.append('file', file);
    const { data } = await apiClient.post('/admin/clients/import-csv', form, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return data;
  },

  exportCsv: async (): Promise<Blob> => {
    const { data } = await apiClient.get('/admin/clients/export-csv', {
      responseType: 'blob',
    });
    return data as Blob;
  },

  listMine: async (params: ListMyClientsParams = {}): Promise<MyClient[]> => {
    const { data } = await apiClient.get<MyClient[]>('/admin/clients/mine', { params });
    return data;
  },

  setBlocked: async (id: string, blocked: boolean): Promise<{ ok: true }> => {
    const { data } = await apiClient.patch<{ ok: true }>(`/admin/clients/${id}/block`, { blocked });
    return data;
  },
};
